
import { Directive } from '@angular/core';

import { NgxSidebarComponent } from './../ngx-sidebar/ngx-sidebar.component';

@Directive({
  selector: '[ngxcloseSidebar]',
  host: {
    '(click)': '_onClick()'
  }
})
export class NgxCloseSidebarDirective {
  constructor(private _sidebar: NgxSidebarComponent) {}

  /** @internal */
  _onClick(): void {
    if (this._sidebar) {
      this._sidebar.close();
    }
  }
}
